var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDailyDose = function SvgIconDailyDose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.976 0c-1.084 0-1.928.895-1.928 2v3H8.072c-1.205 0-2.048.896-2.048 2v3H2.048C.964 10 0 10.897 0 12v6c0 1.105.964 2 2.048 2h16.024C19.157 20 20 19.105 20 18V2c0-1.105-.843-2-1.928-2zm-1.928 18V7H8.072v11zm1.928 0h4.096V2h-4.096v16m-7.952-6v6H2.048v-6z",
    className: "icon_daily_dose_svg__nav-icon"
  })));
};
export default SvgIconDailyDose;